import { __read } from "tslib";
/* eslint-disable @typescript-eslint/prefer-optional-chain */
import { isString } from '@slardar/sdk-template';
import { getFullUrl } from '../../utils';
import { isSensitiveHeader } from '../ajax/util';
export function isHttpURL(url) {
    if (!isString(url)) {
        return false;
    }
    var _a = __read(url.split(':'), 2), protocol = _a[0], path = _a[1];
    return !path || protocol === 'http' || protocol === 'https';
}
export function isRequest(req, Request) {
    return req instanceof Request;
}
export function isHeaders(headers, Headers) {
    return headers instanceof Headers;
}
export var getFetchUrl = function (req, withQuery, Request) {
    if (withQuery === void 0) { withQuery = false; }
    var url = '';
    if (isRequest(req, Request)) {
        url = req.url;
    }
    else {
        url = req;
    }
    if (!withQuery) {
        url = isString(url) ? url.split('?')[0] : url;
    }
    return url;
};
export function mergeHeaders(Headers) {
    var headers = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        headers[_i - 1] = arguments[_i];
    }
    return headers.reduce(function (sum, cur) {
        new Headers(cur).forEach(function (val, key) { return !isSensitiveHeader(key, val) && (sum[key] = val); });
        return sum;
    }, {});
}
export var getFetchMethod = function (req, options, Request) {
    var method = (options && options.method) || 'get';
    if (isRequest(req, Request)) {
        method = req.method || method;
    }
    return method.toLowerCase();
};
export var getFetchBody = function (req, options, Request) {
    if (isRequest(req, Request)) {
        return req.body;
    }
    else {
        return options === null || options === void 0 ? void 0 : options.body;
    }
};
export var getRequestParams = function (url, req, options, Request) {
    return {
        method: getFetchMethod(req, options, Request),
        timestamp: Date.now(),
        url: getFullUrl(url),
    };
};
//# sourceMappingURL=util.js.map